"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLpg24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M8.625 7.179V4.554h6.75v2.625m0 11.25v1.875h-6.75v-1.875m-.25-11.25h7.25a2 2 0 0 1 2 2v7.25a2 2 0 0 1-2 2h-7.25a2 2 0 0 1-2-2v-7.25a2 2 0 0 1 2-2Zm5.828 6.92a2.075 2.075 0 0 1-1.982 1.703c-.926.037-1.748-.505-2.004-1.31-.22-.69-.047-1.446.526-2.313.075-.113.244-.321.394-.501.006.032.014.063.022.093.065.222.15.437.328.508.108.044.28.046.473-.19.419-.516.613-1.209.537-1.91 1.301 1.19 1.939 2.653 1.706 3.92Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgLpg24;
